import {useMutation} from "@tanstack/react-query";
import {reactivateUserManagementUserMutationOptions} from "./reactivate-user-management-user.mutation-options";

export function useReactivateUserManagementUser() {
  return useMutation(reactivateUserManagementUserMutationOptions());
}
